import React from 'react'
import { Link } from 'react-router-dom'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import Menu, { MenuItem } from 'material-ui/Menu'
import Paper from 'material-ui/Paper'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import LanguageSelector from '../i18/languageSelector'

class ForgotForm extends React.Component {

  state = {
    email: '',
    valid: true,
    error: false
  }

  handleChange = (name) => event => {
    this.setState({
      error: false,
      valid: true,
      [name]: event.target.value,
    });
  }

  handleSubmit() {

    if (this.state.email === '') {
      this.setState({ error: true, valid: false })
      return
    }

    let email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let valid = email.test(this.state.email)

    if (!valid) {
      this.setState({ error: true, valid: false })
      return
    }

    this.props.sendEmail({
      email: this.state.email
    })

  }

  render() {

    const {
      classes,
      translate,
    } = this.props

    return (

      <div className={classes.root}>
        <form noValidate autoComplete="off">
          <Paper className={classes.paper}>
            <Typography type="headline">
              {translate('forgot_welcome')}
            </Typography>
            {
              (this.state.valid)
                ? <Valid translate={translate} />
                : <Invalid translate={translate} />
            }
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <TextField
                  error={this.state.error}
                  required
                  id="email"
                  label={translate('forgot_email')}
                  className={classes.textField}
                  fullWidth
                  onChange={this.handleChange('email')}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.handleSubmit();
                      e.preventDefault();
                    }
                  }}
                  value={this.state.email}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  color="accent"
                  raised
                  fullWidth
                  onClick={() => this.handleSubmit()}
                >
                  {translate('forgot_forgot')}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </div>
    )
  }
}

const Valid = ({ translate }) => (
  <Typography color="primary" gutterBottom>
    {translate('forgot_message')}
  </Typography>
)

const Invalid = ({ translate }) => (
  <Typography color="error" gutterBottom>
    {translate('forgot_error')}
  </Typography>
)

export default withStyles(styles)(ForgotForm)
